import { NgModule } from '@angular/core';
import { BaseCustomerDepartmentModule, BaseSharedModule } from 'base';
import { BaseCustomerComponent } from './base-customer.component';
import { BaseCustomerAdministrationModule } from './modules/administration/administration.module';
import { BaseCustomerDashboardModule } from './modules/dashboard/dashboard.module';
import { BaseCustomerProviderModule } from './modules/provider/provider.module';
import { BaseCustomerSharedModule } from './shared/base-customer-shared.module';
import { BaseCustomerOnboardingModule } from './modules/onboarding/onboarding.module';
import { BaseCustomerCustomerDataGuard } from './shared/_guards/base-customer-customer-data.guard';
import { BaseCustomerInquiryModule } from './modules/inquiry/inquiry.module';
import { BaseCustomerServiceProviderGuard } from './shared/_guards/base-customer-service-provider.guard';

@NgModule({
  imports: [
    BaseSharedModule,
    BaseCustomerAdministrationModule,
    BaseCustomerSharedModule,
    BaseCustomerDepartmentModule,
    BaseCustomerInquiryModule,
    BaseCustomerProviderModule,
    BaseCustomerDashboardModule,
    BaseCustomerOnboardingModule,
  ],
  declarations: [BaseCustomerComponent],
  providers: [BaseCustomerCustomerDataGuard, BaseCustomerServiceProviderGuard],
  exports: [
    BaseCustomerComponent,
    BaseCustomerAdministrationModule,
    BaseCustomerSharedModule,
    BaseCustomerDepartmentModule,
    BaseCustomerInquiryModule,
    BaseCustomerProviderModule,
    BaseCustomerDashboardModule,
    BaseCustomerOnboardingModule,
  ],
})
export class BaseCustomerModule {}
